<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Hasil Nilai Akhir'">
          <template v-slot:toolbar>
          </template>
          <template v-slot:body>
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field v-model="hasil.search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="hasil.headers" :items="hasil.isi_data" :search="hasil.search">
                <template v-slot:item.predikat="{ item }">
                  <b-avatar variant="primary" :text="item.predikat"></b-avatar>
                </template>
              </v-data-table>
            </v-card>
          </template>
        </KTCodePreview>

      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";

export default {
  data() {
    return {
      hasil: {
        search: "",
        headers: [
          { text: "No", value: "no" },
          { text: "NIP", value: "nrp" },
          { text: "Nama", value: "lecturer" },
          { text: "Nilai Akhir oleh Staff", value: "score_by_staff" },
          { text: "Nilai Akhir oleh Siswa", value: "score_by_student" },
          { text: "Nilai Akhir", value: "all_score" },
          { text: "Huruf Mutu", value: "predikat" },
        ],
        isi_data: []
      },
      prodi: [
        { text: '--Pilih Prodi--', value: null },
        { text: "DIKREG", value: "DIKREG" },
        { text: "DIKMATRA", value: "DIKMATRA" },
        { text: "SUSJEMESTRA", value: "SUSJEMESTRA" }
      ],
      selectedprodi: '',
    };
  }, 
  components: {
    KTCodePreview,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Evaluasi" },
      { title: "Hasil Evaluasi" },
    ]),
    this.getPenilaianDosen()

  },
  methods: {

    async getPenilaianDosen(){
        try{

          await axios.get('penilaian-dosen/rekap-pengisian/dosen').then(response => {
            if(response.status == 200){
                response.data.data.some( (e,index) => {
                    var obj = {
                        no                : index + 1,
                        nrp               : e.nrp,
                        lecturer          : e.lecturer,
                        score_by_student  : e.score_by_student,
                        score_by_staff    : e.score_by_staff,
                        all_score         : e.all_score,
                        predikat          : e.predikat
                    }
                    this.hasil.isi_data.push(obj);
                  
                })
            }
          })

        }catch(err){
            this.$swal(`Failed`);
        }
    }

  }


}

</script>